// extracted by mini-css-extract-plugin
module.exports = {"favorite":"_fW","favoriteCount":"_fX"};